import React, { useCallback } from "react";
import { type Insets, type StyleProp, StyleSheet, type ViewStyle } from "react-native";

import { isWeb } from "@stepapp/core";

import { palette, spacing } from "../styles";
import Block from "./Block";
import SvgIcon, { type IconNames } from "./SvgIcon";
import Touchable from "./Touchable";

const hitSlops: Insets = {
  top: spacing.unit * 2,
  left: spacing.unit * 2,
  right: spacing.unit * 2,
  bottom: spacing.unit * 2,
};

type Props = {
  onPress?: () => void;
  customIcon?: { name: IconNames; color?: string; size?: number };
  iconName?: IconNames;
  style?: StyleProp<ViewStyle>;
  containerStyle?: StyleProp<ViewStyle>;
  testID?: string;
  size?: number;
};

const HeaderLeft = ({
  onPress,
  iconName = "chevron-left",
  customIcon,
  style,
  containerStyle,
  testID,
  size = 24,
}: Props) => {
  const handlePress = useCallback(() => {
    if (onPress) {
      onPress();
    } else {
      window?.history?.back?.();
    }
  }, [onPress]);

  return (
    <Touchable hitSlop={hitSlops} onPress={handlePress} style={containerStyle} testID={testID}>
      {customIcon ? (
        <Block style={styles.customIcon}>
          <SvgIcon color={customIcon.color} name={customIcon.name} size={size * 1.25} />
        </Block>
      ) : (
        <Block alignCenter justifyCenter style={[styles.iconContainer, style]}>
          <SvgIcon name={iconName} size={size} />
        </Block>
      )}
    </Touchable>
  );
};

export default React.memo(HeaderLeft);

const size = isWeb ? spacing.unit * 4 : spacing.unit * 4.5;

const styles = StyleSheet.create({
  customIcon: {
    paddingLeft: spacing.unit,
    paddingTop: spacing.unit,
  },
  iconContainer: {
    backgroundColor: palette.secondary.grey,
    borderRadius: spacing.radius * 2,
    height: size,
    width: size,
  },
});
